import { has } from 'lodash';
import { createAutocomplete } from '@algolia/autocomplete-core';
export function isPageHit(hit) {
  return has(hit, 'isNewTab');
}
export function isEmbeddedSearchProps(props) {
  return typeof props.showFixedQuery === 'string';
}
export let Segment; // A conventional segment is a Segment whose data source is running
// algoliaClient.search() on some Algolia index. Any other data
// source means the segment is unconventional.

(function (Segment) {
  Segment["stores"] = "stores";
  Segment["retailers"] = "retailers";
  Segment["sites"] = "sites";
  Segment["services"] = "services";
  Segment["offers"] = "offers";
  Segment["events"] = "events";
  Segment["news"] = "news";
  Segment["localStories"] = "localStories";
  Segment["nationalStories"] = "nationalStories";
  Segment["centres"] = "centres";
  Segment["onlineServices"] = "onlineServices";
  Segment["nearCentreStores"] = "nearCentreStores";
  Segment["westfieldProducts"] = "westfieldProducts";
  Segment["products"] = "products";
  Segment["productCollections"] = "productCollections";
  Segment["contentfulBrands"] = "contentfulBrands";
  Segment["facetBrands"] = "facetBrands";
  Segment["emptySearchSuggestions"] = "emptySearchSuggestions";
  Segment["productQuerySuggestions"] = "productQuerySuggestions";
})(Segment || (Segment = {}));

export function isConventionalSegment(segment) {
  return segment !== Segment.facetBrands;
}
export function isSegment(maybeSegment) {
  return maybeSegment in Segment;
}
export function assertSegment(maybeSegment) {
  if (isSegment(maybeSegment)) {
    return maybeSegment;
  } else {
    throw new Error("Unknown segment ".concat(maybeSegment));
  }
}
// Trick to get types out of a generic function
export const createAutocompleteMyType = createAutocomplete;